import { toast } from 'sonner';
import { Eye, Download, FileCheck2 } from 'lucide-react';
import { Button } from '../ui/button';
import { telecharger } from '../qualiopi/shared';
import { dateFR } from './constantes';

const url = (annee) => `/conseil-perfectionnement/${annee}/compte-rendu.pdf`;
const nom = (annee) => `PV_Conseil_perfectionnement_${annee}.pdf`;

export const telechargerPV = (annee) => telecharger(url(annee), nom(annee)).catch(() => toast.error('Téléchargement impossible'));
export const voirPV = (onPdf, annee) => onPdf(null, `Procès-verbal ${annee}`, url(annee));

export const BoutonsPV = ({ annee, onPdf, clair = false, prefixe = 'cp-pv' }) => (
  <div className="flex flex-wrap gap-2">
    <Button size="sm" variant={clair ? 'secondary' : 'outline'} className="rounded-full" onClick={() => voirPV(onPdf, annee)} data-testid={`${prefixe}-voir-${annee}`}>
      <Eye className="mr-1.5 h-4 w-4" /> Voir
    </Button>
    <Button size="sm" variant={clair ? 'secondary' : 'outline'} className="rounded-full" onClick={() => telechargerPV(annee)} data-testid={`${prefixe}-telecharger-${annee}`}>
      <Download className="mr-1.5 h-4 w-4" /> Télécharger
    </Button>
  </div>
);

export const PVValides = ({ liste, onPdf }) => {
  const valides = liste.filter((c) => c.statut === 'cloture');
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="cp-pv-liste">
      <h2 className="flex items-center gap-2 text-base md:text-lg font-semibold text-[#0F172A]">
        <FileCheck2 className="h-5 w-5 text-[#8DC63F]" /> Comptes rendus validés
      </h2>
      {valides.length === 0 && <p className="mt-2 text-sm text-slate-400" data-testid="cp-pv-liste-vide">Aucun compte rendu validé pour l'instant.</p>}
      <ul className="mt-3 divide-y divide-slate-100">
        {valides.map((c) => (
          <li key={c.annee} className="flex flex-wrap items-center justify-between gap-3 py-3" data-testid={`cp-pv-ligne-${c.annee}`}>
            <div>
              <p className="font-semibold text-[#0F172A]">Conseil {c.annee}</p>
              <p className="text-xs text-slate-500">Séance du {c.date ? dateFR(c.date) : '—'} · validé le {dateFR(c.valide_le)}</p>
            </div>
            <BoutonsPV annee={c.annee} onPdf={onPdf} prefixe="cp-pv-liste" />
          </li>
        ))}
      </ul>
    </section>
  );
};
